import React, { useState, useEffect } from 'react';
import { Card, CardMedia, CardContent, Typography, Button, Grid, Box } from '@mui/material';
import './Noticias.css';

const Noticias = () => {
  const media = (fileName) => encodeURI(`/media/homecards/${fileName}`);

  const noticiasData = [
    {
      src: media('capa_ArtigoI.jpeg'),
      text: 'Livro analisa as funções moralizantes dos exempla (plural de exemplum), refletindo sobre as contribuições que esses relatos breves tiveram na fixação de valores e condutas nos diversos públicos das terras ibéricas, no medievo e no início do período moderno.',
      label: 'Leia a resenha',
      path: '/DivulgacaoCientifica'
    },
    {
      src: media('imagemfundoDivulgacao.jpg'),
      text: 'Estamos animados em anunciar o lançamento de novos episódios do nosso podcast! 📢',
      label: 'Divulgação Científica',
      path: '/DivulgacaoCientifica'
    }, {
      src: media('ACIESP Celebra 50 Anos com Evento Dedicado aos Jovens Pesquisadores.webp'),
      text: 'Promovido pela ACIESP em colaboração com a FAPESP e a ABC, este encontro é dedicado aos jovens pesquisadores e tem como objetivo discutir o futuro da ciência no Brasil.',
      label: 'Jovens Pesquisadores e a Ciência no Brasil',
      path: 'https://aciesp.org.br/jovens-pesquisadores/'
    },
    {
      src: media('Textos medievais sobre moral cristã reunidos em banco de dados.jpeg'),
      text: 'Banco de dados reúne textos criados para difundir a moral cristã no fim da Idade Média.',
      label: 'Textos medievais sobre moral cristã reunidos em banco de dados',
      path: 'https://agencia.fapesp.br/banco-de-dados-reune-textos-criados-para-difundir-a-moral-crista-no-fim-da-idade-media/37930/'
    },
    {
      src: media('Brasileiros e Suíços Unem Forças em Projetos de Pesquisa Multidisciplinares.jpeg'),
      text: 'Brasileiros e suíços se unem para estudar temas que vão de narrativas medievais a computadores quânticos.',
      label: 'Brasileiros e Suíços Unem Forças em Projetos de Pesquisa Multidisciplinares',
      path: 'https://agencia.fapesp.br/brasileiros-e-suicos-se-unem-para-estudar-temas-que-vao-de-narrativas-medievais-a-computadores-quanticos/37178/'
    },
    {
      src: media('Colóquio "Exemplum".jpg'),
      text: 'Realizou-se na Universidade de Friburgo o simpósio "Exemplum e discurso exemplar na Península Ibérica (sec. XIII-XVII)".',
      label: 'Colóquio "Exemplum"',
      path: 'https://www.unifr.ch/esp/es/news/news/29293/?utm_source=news&utm_medium=&utm_campaign=redirection_from_homehttp%3A%2F%2Fwww.unifr.ch%2Fesp%2Fes%2F'
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % noticiasData.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + noticiasData.length) % noticiasData.length
    );
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 13000);
    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  return (
    <section className="noticias" id="ultimasnoticias">
    <div className="container">
      <div className="row"> 
        <div className="col-12">
          <div className="noticias-bx wow zoomIn" style={{ textAlign: 'center', marginBottom: '30px' }}>
             <Typography
                variant="h2"
                align="center"
                gutterBottom
                style={{
                  fontFamily: "'Lato', serif",
                  color: "#800020",
                  borderBottom: "4px solid #d4af37",
                  paddingBottom: "10px",
                  textTransform: "uppercase",
                  animation: "glow 2s infinite alternate",
                  textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  marginTop: "7%"  // Aqui é onde você define o espaço superior
                }}
              >Últimas notícias</Typography>
            
            <Typography 
                variant="body1" 
                color="textSecondary" 
                sx={{ fontFamily: 'Georgia, serif' }} // Define uma fonte serifada para combinar com o tema histórico
              >
            Fique por dentro das últimas atualizações do nosso projeto! Acompanhe novos documentos, verbetes e informações sobre eventos importantes. Mantenha-se informado e participe ativamente dessa jornada conosco            
            </Typography>
             <Grid container spacing={4} justifyContent="center">
              {noticiasData
                .slice(currentIndex, currentIndex + 3)
                .map((noticia, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      height: '100%',
                      borderRadius: '12px',
                      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                      }
                    }}>
                      {/* Card Image com altura fixa */}
                      <CardMedia
                        component="img"
                        alt={noticia.label}
                        height="180" // Altura fixa para imagem
                        image={noticia.src}
                        title={noticia.label}
                        sx={{ objectFit: 'cover', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}
                      />
                      <CardContent sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, padding: '20px' }}>
                        {/* Título */}
<Typography 
    variant="h4" 
    color="textSecondary" 
    sx={{ fontFamily: 'Lato, serif' }} 
  >                          {noticia.label}
                        </Typography>
                        {/* Subtítulo */}
                        <Typography 
                            variant="body1" 
                            color="textSecondary" 
                            sx={{ fontFamily: 'Georgia, serif' }}  
                          >
                          {noticia.text}
                        </Typography>
                      </CardContent>
                      {/* Botão */}
                      <Box sx={{ padding: '16px' }}>

              <Button
            
            variant="contained"
            color="primary"
            href={noticia.path}
            target="_blank"
             rel="noopener noreferrer"
            sx={{
              fontWeight: 'bold',
              textTransform: 'none',
              borderRadius: '25px',
              backgroundColor: '#d4af37', // Cor de fundo amarela
              padding: '12px 24px', // Aumenta o tamanho do botão (altura e largura)
              fontSize: '18px', // Aumenta o tamanho da fonte
              '&:hover': {
                backgroundColor: '#800020', // Cor de fundo ao passar o mouse
                transform: 'scale(1.1)', // Aumenta mais o botão ao passar o mouse
                transition: 'transform 0.3s ease, background-color 0.3s ease', // Efeito suave
              },
            }}
            
          >
 
                          Saiba mais
                        </Button>
                      </Box>
                    </Card>
                  </Grid>
                ))}
            </Grid>
            {/* Navegação do carrossel */}
            <Box sx={{
              marginTop: '30px',
              display: 'flex',
              justifyContent: 'space-between',
              width: '50%',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={prevSlide}
                sx={{
                  padding: '10px 20px',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  borderRadius: '8px',
                  '&:hover': {
                    borderColor: '#dc3545',
                    color: '#dc3545',
                  }
                }}
              >
                Anterior
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={nextSlide}
                sx={{
                  padding: '10px 20px',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  borderRadius: '8px',
                  '&:hover': {
                    borderColor: '#007bff',
                    color: '#007bff',
                  }
                }}
              >
                Próximo
              </Button>
            </Box>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default Noticias;
